<img
     *ngIf="isNgOptimizedImageSupported; else fallbackImage"
     #img
     [alt]="productName"
     [class]="imgClasses"
     [height]="height"
     [ngSrc]="imageSrc"
     [priority]="isLCPImage"
     [title]="productName"
     [width]="width"
     (error)="handleImageError(img.src)"
     itemprop="image"
/>

<ng-template #fallbackImage>
  <img
     #img
     [alt]="productName"
     [class]="imgClasses"
     [height]="height"
     [src]="imageSrc"
     [title]="productName"
     [width]="width"
     loading="lazy"
     (error)="handleImageError(img.src)"
     itemprop="image"
  />
</ng-template>
